<div id="slides" *ngIf="backgrounds && backgrounds.length > 1">
  <div class="slide" [class.showing]="idx == currentSlide" *ngFor="let slide of backgrounds; let idx = index"
       [ngStyle]="{'background-image': safeUrl(slide),  'background-position': 'center', 'background-size': 'cover' ,'background-attachment': 'fixed'}">
  </div>
</div>
<div id="slides" *ngIf="backgrounds && backgrounds.length == 1">
  <div class="slide showing" [ngStyle]="{'background-image': safeUrl(backgrounds[0]),  'background-position': 'center', 'background-size': 'cover' ,'background-attachment': 'fixed'}">
  </div>
</div>